<template>
  <div>
    خانه
  </div>
</template>

<script>
export default {
  mounted() {
    if (this.$store.state.layout != "app-layout") this.$setLayout("app-layout");
  },
};
</script>

<style lang="scss" scoped></style>
